import * as ACTIONS_TYPE from '../actions/actionsTypes';

export const initialState = {
    tipoMercadoVisa: false,
    tipoMercadoSafetyPay: false,
    tipoMercadoPagoLink: false,
    data: null,
    mensajeError: null
}

export const PagoReducer = (state, action) => {
    switch(action.type) {
        case ACTIONS_TYPE.SET_TIPO_MERCADO:
            return {
                ...state,
                tipoMercadoVisa: action.payload.tipoMercadoVisa,
                tipoMercadoSafetyPay: action.payload.tipoMercadoSafetyPay,
                tipoMercadoPagoLink: action.payload.tipoMercadoPagoLink,
                mensajeError: null,
                data: null,
            }
        case ACTIONS_TYPE.SET_MENSAJE_ERROR:
            return {
                ...state,
                mensajeError: action.payload.mensajeError
            }
        case ACTIONS_TYPE.SET_DATA_VISA:
            return {
                ...state,
                data: action.payload.data
            }
        case ACTIONS_TYPE.SET_DATA_SAFETYPAY:
            return {
                ...state,
                data: action.payload.data
            }
        case ACTIONS_TYPE.SET_DATA_PAGOLINK:
            return {
                ...state,
                data: action.payload.data
            }
        default:
            return state
    }
}